export default "__VITE_ASSET__CbVsxhRO__"